<footer class="footer mt-auto" id="page-footer">
  <div class="copyright bg-white">
    <p>
      &copy; {{year}} Copyright Ormer ICT - <a class="text-primary" href="http://www.tymes4.com/" target="_blank">Tymes 4</a>.
    </p>
  </div>
</footer>
